var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgImage = function SvgImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 11.667v3a2 2 0 0 0 2 2h8.625m-10.625-5v-5.5a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v6.75m-15-1.25 2.716-2.328a2 2 0 0 1 2.929.356L10 12.292m3.125 4.375H15.5a2 2 0 0 0 2-2v-1.75m-4.375 3.75L10 12.292m0 0 1.944-1.556a2 2 0 0 1 2.412-.065l3.144 2.246",
    stroke: "#818C96",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgImage;